function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
const createResult = (data, direction) => {
  if (direction === 'x') {
    return {
      x: data,
      y: null
    };
  }
  return {
    x: null,
    y: data
  };
};
const getBaseExtremum = params => {
  var _axis$data;
  const axis = params.axis,
    getFilters = params.getFilters,
    isDefaultAxis = params.isDefaultAxis;
  const filter = getFilters === null || getFilters === void 0 ? void 0 : getFilters({
    currentAxisId: axis.id,
    isDefaultAxis
  });
  const data = filter ? (_axis$data = axis.data) === null || _axis$data === void 0 ? void 0 : _axis$data.filter((_, i) => filter({
    x: null,
    y: null
  }, i)) : axis.data;
  const minX = Math.min(...(data !== null && data !== void 0 ? data : []));
  const maxX = Math.max(...(data !== null && data !== void 0 ? data : []));
  return [minX, maxX];
};
const getValueExtremum = direction => params => {
  const series = params.series,
    axis = params.axis,
    getFilters = params.getFilters,
    isDefaultAxis = params.isDefaultAxis;
  return Object.keys(series).filter(seriesId => {
    var _series$seriesId$yAxi;
    const yAxisId = (_series$seriesId$yAxi = series[seriesId].yAxisId) !== null && _series$seriesId$yAxi !== void 0 ? _series$seriesId$yAxi : series[seriesId].yAxisKey;
    return yAxisId === axis.id || isDefaultAxis && yAxisId === undefined;
  }).reduce((acc, seriesId) => {
    var _series$seriesId$xAxi, _series$seriesId$yAxi2, _stackedData$reduce;
    const stackedData = series[seriesId].stackedData;
    const filter = getFilters === null || getFilters === void 0 ? void 0 : getFilters({
      currentAxisId: axis.id,
      isDefaultAxis,
      seriesXAxisId: (_series$seriesId$xAxi = series[seriesId].xAxisId) !== null && _series$seriesId$xAxi !== void 0 ? _series$seriesId$xAxi : series[seriesId].xAxisKey,
      seriesYAxisId: (_series$seriesId$yAxi2 = series[seriesId].yAxisId) !== null && _series$seriesId$yAxi2 !== void 0 ? _series$seriesId$yAxi2 : series[seriesId].yAxisKey
    });
    const _ref = (_stackedData$reduce = stackedData === null || stackedData === void 0 ? void 0 : stackedData.reduce((seriesAcc, values, index) => {
        if (filter && (!filter(createResult(values[0], direction), index) || !filter(createResult(values[1], direction), index))) {
          return seriesAcc;
        }
        return [Math.min(...values, seriesAcc[0]), Math.max(...values, seriesAcc[1])];
      }, [Infinity, -Infinity])) !== null && _stackedData$reduce !== void 0 ? _stackedData$reduce : [Infinity, -Infinity],
      _ref2 = _slicedToArray(_ref, 2),
      seriesMin = _ref2[0],
      seriesMax = _ref2[1];
    return [Math.min(seriesMin, acc[0]), Math.max(seriesMax, acc[1])];
  }, [Infinity, -Infinity]);
};
export const getExtremumX = params => {
  // Notice that bar should be all horizontal or all vertical.
  // Don't think it's a problem for now
  const isHorizontal = Object.keys(params.series).some(seriesId => params.series[seriesId].layout === 'horizontal');
  if (isHorizontal) {
    return getValueExtremum('x')(params);
  }
  return getBaseExtremum(params);
};
export const getExtremumY = params => {
  const isHorizontal = Object.keys(params.series).some(seriesId => params.series[seriesId].layout === 'horizontal');
  if (isHorizontal) {
    return getBaseExtremum(params);
  }
  return getValueExtremum('y')(params);
};